export default __webpack_public_path__ + "static/industry-experts-f1862c4c85b0fd5a3d95accc7100322b.svg";